import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import Loading from "./loading.js";
import { secretKey } from "./data";
import { downloadExcel } from "react-export-table-to-excel";

const MySwal = withReactContent(Swal2);

const ImportLead = (props) => {
  const [loading, setLoading] = useState(true);
  const [sources, setSources] = useState([]);
  const [array, setArray] = useState([]);
  const [arrayNon, setArrayNon] = useState([]);
  const [fileInfo, setFileInfo] = useState([]);

  const fileReader = new FileReader();

  const fetchLeadSources = async () => {
    await fetch("https://apiftpsplit.ftpeople.pl/getLeadSources", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify({}),
    })
      .then((response) => response.json())
      .then((data) => {
        setSources(data.filter((el) => el.name !== "Polecenie"));
        setLoading(false);
      })
      .catch(() => {});
  };

  const fetchLeadsImport = async () => {
    await fetch("https://apiftpsplit.ftpeople.pl/importLeads", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify({ leads: array }),
    })
      .then((response) => response.text())
      .then(() => {
        MySwal.fire({
          icon: "success",
          title: "Zaimportowano",
          text: "leady",
          customClass: {
            popup: "swal-crm-popup",
            title: "swal-crm-title",
            htmlContainer: "swal-crm-html",
            confirmButton: "swal-crm-confirm",
          },
        }).then(() => props.close());
      })
      .catch(() => {});
  };

  useEffect(() => {
    setLoading(true);
    fetchLeadSources();
  }, []);

  const validate = () => array.length > 0;

  const importLead = () => {
    if (validate()) {
      setLoading(true);
      fetchLeadsImport();
    } else {
      MySwal.fire({
        icon: "error",
        title: "Wgraj",
        text: "prawidłowy plik",
        customClass: {
          popup: "swal-crm-popup",
          title: "swal-crm-title",
          htmlContainer: "swal-crm-html",
          confirmButton: "swal-crm-confirm",
        },
      });
    }
  };

  const checkSource = (source) => sources.some((e) => e.name === source);

  const checkCompany = (company) =>
    props.companies.some((e) => e.name === company);

  const csvFileToArray = (string) => {
    const csvRows = string.slice(string.indexOf("\n") + 1).split("\n");

    const array1 = [];
    const arrayN = [];

    csvRows.forEach((i) => {
      const values = i.split(";");
      const source = values[3]?.trim() ?? false;
      const company = values[6]?.trim() ?? "";
      const idSource = values[7]?.trim() ?? "";

      if (checkSource(source) && checkCompany(company)) {
        array1.push({
          name: values[0],
          phone: values[1],
          mail: values[2],
          source: values[3],
          sourceNote: values[4],
          sourceLink: values[5],
          company,
          idSource,
        });
      } else if (values.length !== 1) {
        arrayN.push({
          name: values[0],
          phone: values[1],
          mail: values[2],
          source: values[3],
          sourceNote: values[4],
          sourceLink: values[5],
          company,
          idSource,
        });
      }
    });

    setFileInfo({
      rows: csvRows.filter(
        (i) => i.split(";")[3] !== undefined && i.split(";")[3] !== ""
      ).length,
      rowsAcc: array1.length,
    });

    setArray(array1);
    setArrayNon(arrayN);
    setLoading(false);
  };

  const readFile = (e) => {
    if (e.target.files[0]) {
      e.preventDefault();
      setLoading(true);
      fileReader.onload = (event) => csvFileToArray(event.target.result);
      fileReader.readAsText(e.target.files[0], "Windows-1250");
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
        customClass: {
          popup: "swal-crm-popup",
          title: "swal-crm-title",
          htmlContainer: "swal-crm-html",
          confirmButton: "swal-crm-confirm",
        },
      });
    }
  };

  const exportArrayNon = () => {
    const header = [
      "name",
      "phone",
      "mail",
      "source",
      "source note",
      "source link",
      "company",
      "id source",
    ];
    const body = arrayNon.map((el) => [
      el.name,
      el.phone,
      el.mail,
      el.source,
      el.sourceNote,
      el.sourceLink,
      el.company,
      el.idSource,
    ]);
    downloadExcel({
      fileName: "importNon_report_" + new Date(),
      sheet: "data",
      tablePayload: { header, body },
    });
  };

  return (
    <div className="il-overlay">
      <div className="il-panel">
        {loading ? (
          <Loading />
        ) : (
          <>
            {/* Header */}
            <div className="il-header">
              <div className="il-header-left">
                <div
                  className="sidebar-logo"
                  style={{ width: 40, height: 40, fontSize: 17 }}
                >
                  IL
                </div>
                <div>
                  <h2 className="il-title">Importuj Leady</h2>
                  <a
                    className="il-example-link"
                    href="https://ftpeople.pl/wp-content/uploads/2024/03/lead_splitter_example-1-1.csv"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Pobierz przykładowy plik CSV →
                  </a>
                </div>
              </div>
              <button
                className="ld-close"
                onClick={props.close}
                title="Zamknij"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="il-body">
              {/* Upload zone */}
              <div className="rp-section">
                <span className="rp-section-label">Plik CSV</span>
                <label className="af-drop-zone">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                    <polyline points="17 8 12 3 7 8" />
                    <line x1="12" y1="3" x2="12" y2="15" />
                  </svg>
                  Kliknij lub przeciągnij plik
                  <input
                    className="af-file-input"
                    type="file"
                    accept=".csv"
                    onChange={readFile}
                  />
                </label>
              </div>

              {/* Stats */}
              <div className="il-stats">
                <div className="il-stat">
                  <span className="il-stat-label">Wszystkich rekordów</span>
                  <span className="il-stat-value">{fileInfo.rows ?? 0}</span>
                </div>
                <div className="il-stat il-stat--ok">
                  <span className="il-stat-label">Prawidłowych</span>
                  <span className="il-stat-value il-stat-value--ok">
                    {fileInfo.rowsAcc ?? 0}
                  </span>
                </div>
                {arrayNon.length > 0 && (
                  <div className="il-stat il-stat--err">
                    <span className="il-stat-label">Nieprawidłowych</span>
                    <span className="il-stat-value il-stat-value--err">
                      {arrayNon.length}
                    </span>
                  </div>
                )}
              </div>

              {/* Download invalid */}
              {arrayNon.length > 0 && (
                <button
                  className="lq-btn lq-btn--muted il-export-btn"
                  onClick={exportArrayNon}
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                  >
                    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                  </svg>
                  Pobierz nieprawidłowe ({arrayNon.length})
                </button>
              )}
            </div>

            {/* Footer */}
            <div className="il-footer">
              <button className="lq-btn lq-btn--muted" onClick={props.close}>
                Anuluj
              </button>
              <button
                className="lq-btn lq-btn--primary"
                onClick={importLead}
                disabled={array.length === 0}
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                >
                  <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                  <polyline points="17 8 12 3 7 8" />
                  <line x1="12" y1="3" x2="12" y2="15" />
                </svg>
                Importuj {array.length > 0 ? `(${array.length})` : ""}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ImportLead;
